import useSWR from "swr";

import { Card } from "@/components/ui/card";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const fetcher = (url: string) => fetch(url, { credentials: "include" }).then((res) => res.json());

function buildDataset(entries: { date: string; predicted: number; interval_low: number; interval_high: number }[]) {
  return {
    labels: entries.map((entry) => entry.date),
    datasets: [
      {
        label: "Predicted",
        data: entries.map((entry) => entry.predicted),
        borderColor: "#34d399",
        backgroundColor: "rgba(52, 211, 153, 0.2)",
        fill: true,
        tension: 0.4,
      },
      {
        label: "Low",
        data: entries.map((entry) => entry.interval_low),
        borderColor: "rgba(52, 211, 153, 0.1)",
        borderDash: [4, 4],
        fill: false,
      },
      {
        label: "High",
        data: entries.map((entry) => entry.interval_high),
        borderColor: "rgba(52, 211, 153, 0.1)",
        borderDash: [4, 4],
        fill: false,
      },
    ],
  };
}

export function AudienceForecastPanel() {
  const { data, isLoading } = useSWR("/marketing/analytics/forecast", fetcher);
  const instagram = data?.instagram?.predictions ?? [];

  return (
    <Card className="space-y-4 border-border/70 bg-background/40 p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-foreground">Audience Forecast</p>
          <p className="text-xs text-muted-foreground">Projected follower/stream growth.</p>
        </div>
      </div>
      {isLoading ? (
        <p className="text-xs text-muted-foreground">Forecasting…</p>
      ) : instagram.length ? (
        <Line data={buildDataset(instagram)} options={{ plugins: { legend: { display: false } } }} />
      ) : (
        <p className="text-xs text-muted-foreground">No forecast yet.</p>
      )}
      <div className="grid gap-3 text-xs text-muted-foreground md:grid-cols-2">
        <div>
          <p className="font-semibold text-foreground/80">TikTok scenario</p>
          <p>Posting daily could reach ~{Math.round((data?.tiktok?.scenario_daily ?? [])[5] ?? 0).toLocaleString()} followers.</p>
        </div>
        <div>
          <p className="font-semibold text-foreground/80">Spotify</p>
          <p>{(data?.spotify?.predicted_streams ?? 0).toLocaleString()} streams · {(data?.spotify?.predicted_listeners ?? 0).toLocaleString()} listeners</p>
        </div>
      </div>
    </Card>
  );
}
